/*
 * File: /src/shared/validatePhone.js
 * Created Date: Sunday October 20th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 20th October 2019 6:08:15 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import PhoneNumber from 'awesome-phonenumber';

export const validatePhone = (phone) => {
  const phoneNumber = new PhoneNumber(phone, 'US');
  return phoneNumber.isValid();
};
